import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  get_single_article,
  get_single_article_comments,
  submit_comment,
  submit_comment_reset_status,
  like_article,
  dislike_article,
  like_article_reset_status,
  follow_user,
  unfollow_user,
  follow_user_reset_status,
  delete_comment,
  delete_comment_reset,
} from "../../redux/actions";
import Comments from "../../components/comments";
import ToastNotification from "../../components/toastNotification";
import {
  Col,
  Container,
  Row,
  Image,
  ToggleButton,
  Button,
  Card,
  InputGroup,
  FormControl,
} from "react-bootstrap";

export default function SinglePageArticle() {
  const params = useParams();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state);
  const [articleComment, setArticleComment] = useState();
  useEffect(() => {
    dispatch(
      get_single_article(
        "get",
        `${process.env.REACT_APP_URL}/api/articles/${params.slug}`
      )
    );
    dispatch(
      get_single_article_comments(
        "get",
        `${process.env.REACT_APP_URL}/api/articles/${params.slug}/comments`
      )
    );
  }, []);

  useEffect(() => {
    if (globalState.commentPosted) {
      dispatch(
        get_single_article_comments(
          "get",
          `${process.env.REACT_APP_URL}/api/articles/${params.slug}/comments`
        )
      );
      dispatch(submit_comment_reset_status());
    }
  }, [globalState.commentPosted]);

  useEffect(() => {
    // if (globalState.articleLiked) {
    dispatch(
      get_single_article(
        "get",
        `${process.env.REACT_APP_URL}/api/articles/${params.slug}`
      )
    );
    dispatch(like_article_reset_status());
    // }
  }, [globalState.articleLiked]);

  useEffect(() => {
    // if (globalState.articleLiked) {
    dispatch(
      get_single_article(
        "get",
        `${process.env.REACT_APP_URL}/api/articles/${params.slug}`
      )
    );
    dispatch(follow_user_reset_status());
    // }
  }, [globalState.userFollowed]);

  // globalState.singlePost.author.following

  function setReadableDate(date) {
    const readableDate = new Date(date);
    return readableDate.toDateString();
  }

  function putComment(e) {
    setArticleComment(e.target.value);
  }

  function submitComment() {
    if (articleComment) {
      const commentObject = {
        comment: { body: articleComment },
      };
      dispatch(
        submit_comment(
          "post",
          `${process.env.REACT_APP_URL}/api/articles/${params.slug}/comments`,
          commentObject
        )
      );
    }
  }

  function likeButtonClickHandler() {
    if (!globalState.singlePost.favorited) {
      dispatch(
        like_article(
          "post",
          `${process.env.REACT_APP_URL}/api/articles/${params.slug}/favorite`
        )
      );
    } else if (globalState.singlePost.favorited) {
      dispatch(
        dislike_article(
          "delete",
          `${process.env.REACT_APP_URL}/api/articles/${params.slug}/favorite`
        )
      );
    }
  }

  function followButtonClickHandler() {
    if (!globalState.singlePost.author.following) {
      dispatch(
        follow_user(
          "post",
          `${process.env.REACT_APP_URL}/api/profiles/${globalState.singlePost.author.id}/follow`
        )
      );
    } else if (globalState.singlePost.author.following) {
      dispatch(
        unfollow_user(
          "delete",
          `${process.env.REACT_APP_URL}/api/profiles/${globalState.singlePost.author.id}/follow`
        )
      );
    }
  }

  function deleteClickHandler(e) {
    dispatch(
      delete_comment(
        "delete",
        `${process.env.REACT_APP_URL}/api/articles/${params.slug}/comments/${e}`
      )
    );
  }

  useEffect(() => {
    if (globalState.commentDeleted) {
      dispatch(
        get_single_article_comments(
          "get",
          `${process.env.REACT_APP_URL}/api/articles/${params.slug}/comments`
        )
      );
      dispatch(delete_comment_reset());
    }
  }, [globalState.commentDeleted]);

  return globalState.singlePost ? (
    <div className="main-page-div">
      {/* <ToastNotification show={true} autoHide={true}/> */}
      <Container>
        <Row>
          <Col sm={12} md={8}>
            <div>
              <Image
                className="single-article-post-title-image"
                src={globalState.singlePost.titleImage}
                fluid
              />
              <h1>{globalState.singlePost.title}</h1>
              {globalState.singlePost.description && (
                <h3>{globalState.singlePost.description}</h3>
              )}
              {globalState.singlePost.tagList && (
                <small className="d-flex text-muted">
                  {/* <div className="d-flex"> */}
                  {globalState.singlePost.tagList &&
                    globalState.singlePost.tagList.map((item, index) => (
                      <div
                        key={index}
                        className="border border-secondary rounded-pill px-3"
                      >
                        <Card.Text>{item}</Card.Text>
                      </div>
                    ))}
                  {/* </div> */}
                </small>
              )}
              <div>
                <small className="text-muted">
                  <Link to={`/user/${globalState.singlePost.author.id}`}>
                    {globalState.singlePost.author.first_name +
                      " " +
                      globalState.singlePost.author.last_name}
                  </Link>
                </small>
                <small className="text-muted d-block">
                  {setReadableDate(globalState.singlePost.createdAt)}
                </small>
              </div>
              <hr />
              {globalState.singlePost.body && (
                <div
                  className="single-post-body-div"
                  dangerouslySetInnerHTML={{
                    __html: globalState.singlePost.body,
                  }}
                ></div>
              )}
            </div>
            <hr />
            <div>
              <h3>Comments:</h3>
              {globalState.singlePostComments &&
                globalState.singlePostComments.map((item, index) => (
                  <Comments
                    key={index}
                    deleteClickHandler={deleteClickHandler}
                    user={globalState.user}
                    item={item}
                  />
                ))}
              <InputGroup>
                <Button
                  onClick={submitComment}
                  variant="outline-secondary"
                  id="button-addon1"
                >
                  Submit Here
                </Button>
                <FormControl
                  as="textarea"
                  placeholder="Join the discussion and leave a comment!"
                  aria-label="With textarea"
                  value={articleComment}
                  onChange={putComment}
                />
              </InputGroup>
            </div>
          </Col>
          <Col sm={12} md={4}>
            <ToggleButton
              //   className="mb-2"
              id="toggle-check"
              type="checkbox"
              variant="outline-primary"
              checked={globalState.singlePost.favorited ? true : false}
              value="1"
              //   onChange={(e) => setChecked(e.currentTarget.checked)}
              onClick={likeButtonClickHandler}
            >
              {globalState.singlePost.favorited ? "Dislike" : "Like"}{" "}
              {globalState.singlePost.favoritesCount > 0 &&
                "| " + globalState.singlePost.favoritesCount}
              {/* <i className="bi bi-star" /> */}
            </ToggleButton>
            {globalState.isAuthenticated &&
              globalState.user.id !== globalState.singlePost.author.id && (
                // <Button onClick={followButtonClickHandler} variant="primary">Follow</Button>
                <ToggleButton
                  id="toggle-check"
                  type="checkbox"
                  variant="outline-primary"
                  checked={
                    globalState.singlePost.author.following ? true : false
                  }
                  value="1"
                  onClick={followButtonClickHandler}
                >
                  {globalState.singlePost.author.following
                    ? "Unfollow"
                    : "Follow"}{" "}
                </ToggleButton>
              )}
          </Col>
        </Row>
      </Container>
    </div>
  ) : (
    <div>Loading...</div>
  );
}
